import workspaceQuery from 'graphql/queries/salesLedger/SalesBadDebtWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/salesLedger/SalesBadDebtQuery.graphql';
import defaultQuery from 'graphql/queries/salesLedger/SalesBadDebtDefault.graphql';
import mutationQuery from 'graphql/mutations/salesLedger/SalesBadDebtMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/salesLedger/SaveSalesBadDebtTempMutation.graphql';
import fragment from 'graphql/fragments/salesLedger/SalesBadDebtFragment.graphql';
import aggregateQuery from 'graphql/queries/salesLedger/SalesBadDebtAggregateQuery.graphql';

import { formActions } from 'actions/salesLedger/SalesBadDebtAction';

const SalesBadDebt = {
  type: 'SalesBadDebt',
  title: 'Customer Bad Debt',
  formTitle: 'Customer Bad Debt',
  formUrl: '/Customers/BadDebt/Details/',
  workspaceUrl: '/Customers/BadDebt/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'SALES_LEDGER_BAD_DEBT',
  actions: formActions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
};

export default SalesBadDebt;
